
    <mat-card class="table-card" style="min-height: calc(100vh - 140px) !important;">
        <span>
            <div class="table-header">
                
                <span class="d-flex align-items-center">
                    <button
                        mat-icon-button
                        aria-label="filter user"
                        class="mr-30"
                        [matMenuTriggerFor]="filterOptions"
                        (menuClosed)="(this.checkIfFilters()) && applyFilters()"
                        matTooltip="Filter"
                        [matTooltipShowDelay]="tooltipDelay"
                        matTooltipPosition="left"
                    >
                        <mat-icon>filter_list</mat-icon>
                    </button>
                    <mat-menu #filterOptions="matMenu" xPosition="before">
                        <form class="filter-form" #filterForm="ngForm">
                            <div class="filter-panel">
                                <ng-container *ngIf="userFilterLists?.language?.length">
                                    <div class="mat-subtitle text-hint">Language</div>
                                    <mat-checkbox
                                        *ngFor="let lang of userFilterLists.language"
                                        [(ngModel)]="lang.checked"
                                        [name]="lang.label"
                                        class="filter-options"
                                        (change)="changeCheckBox('language', lang)"
                                        (click)="$event.stopPropagation()"
                                        >{{ lang.label }}</mat-checkbox
                                    >
                                    <mat-divider></mat-divider>
                                </ng-container>
                                <div class="mat-subtitle text-hint">Gender</div>
                                <mat-checkbox
                                    *ngFor="let gen of userFilterLists.gender"
                                    [(ngModel)]="gen.checked"
                                    [name]="gen.label"
                                    class="filter-options"
                                    (change)="changeCheckBox('gender', gen)"
                                    (click)="$event.stopPropagation()"
                                    >{{ gen.label }}</mat-checkbox
                                >
                                <mat-divider></mat-divider>
                                <div class="mat-subtitle text-hint">Status</div>
                                <mat-checkbox
                                    *ngFor="let usr of userFilterLists.active"
                                    [(ngModel)]="usr.checked"
                                    [name]="usr.label"
                                    class="filter-options"
                                    (change)="changeCheckBox('active', usr)"
                                    (click)="$event.stopPropagation()"
                                    >{{ usr.label }}</mat-checkbox
                                >
                            </div>
                            <div class="filter-action d-flex justify-content-end">
                                <button mat-button type="button" [disabled]="!hasFilters" (click)="clearFilter($event)">
                                    <span [class.text-hint]="hasFilters">Clear All</span>
                                </button>
                                <button mat-button type="button" color="accent" (click)="(this.checkIfFilters()) && applyFilters()">Apply</button>
                            </div>
                        </form>
                    </mat-menu>

                    <mat-chip-listbox #chipList aria-label="Filters chips" class="py-16">
                        <mat-chip-option *ngFor="let filter of filterChips" removable (removed)="removeFilter(filter.value)">
                            {{ filter.label }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-option>
                    </mat-chip-listbox>
                </span>

                <!-- search-bar -->
                <div class="mat-table-search-bar d-flex align-items-center">
                    <mat-form-field appearance="outline" color="accent" [style.width]="medicaidEnabled ? '520px' : '410px'">
                        <mat-label>{{ searchPlaceholder }}</mat-label>
                        <input
                            matInput
                            type="text"
                            [(ngModel)]="searchValue"
                            (keyup.enter)="searchList()"
                            [matAutocomplete]="auto"
                            cdkFocusInitial
                            #matSearchInpRef
                        />
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of searchAutoComplete" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-autocomplete>
                        <button matSuffix mat-icon-button [color]="matSearchInpRef?.focus ? 'accent' : ''" (click)="searchList()">
                            <mat-icon class="text-hint">search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>

            <div class="table-container">
                <!-- Table -->
                <table
                    mat-table
                    [dataSource]="dataSource"
                    class="mat-elevation-z8"
                    matSort
                    [matSortActive]="usersSelectorParams?.orderBy || 'member_ref'"
                    matSortDisableClear
                    [matSortDirection]="usersSelectorParams?.order || 'desc'"
                    #sort
                >
                
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef class="tiny"></th>
                      <td mat-cell *matCellDef="let row" class="tiny" style="text-align: center;">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="$event ? toggleSelection(row) : null"
                                      [checked]="isSelectedRow(row)" 
                                      [disabled]="isDisabled(row)"
                                      [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    
                    <!-- Memebr ID Column -->
                    <ng-container matColumnDef="member_ref" sticky>
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="medium">Member ID</th>
                        <td mat-cell *matCellDef="let data" class="medium" [matTooltip]="data.member_ref" [matTooltipShowDelay]="tooltipDelay">{{ data.member_ref }}</td>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="fname" sticky>
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="short">First Name</th>
                        <td mat-cell *matCellDef="let data" class="short" [matTooltip]="data.fname" [matTooltipShowDelay]="tooltipDelay">
                            {{ data.fname }}
                        </td>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lname" sticky>
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="short">Last Name</th>
                        <td mat-cell *matCellDef="let data" class="short" [matTooltip]="data.lname" [matTooltipShowDelay]="tooltipDelay">
                            {{ data.lname }}
                        </td>
                    </ng-container>

                    <!-- Gender Column -->
                    <ng-container matColumnDef="gender">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="tiny">Gender</th>
                        <td mat-cell *matCellDef="let data" class="tiny">{{ data.gender | titlecase }}</td>
                    </ng-container>

                    <!-- Mobile Phone Column -->
                    <ng-container matColumnDef="phone_no">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="medium">Phone</th>
                        <td mat-cell *matCellDef="let data" class="medium" [matTooltip]="data.phone_no" [matTooltipShowDelay]="tooltipDelay">
                            {{ data.phone_no }}
                        </td>
                    </ng-container>

                    <!-- Email Address Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="medium">Email Address</th>
                        <td mat-cell *matCellDef="let data" class="medium" [matTooltip]="data.email" [matTooltipShowDelay]="tooltipDelay">
                            {{ data.email }}
                        </td>
                    </ng-container>

                    <!-- Language Column -->
                    <ng-container matColumnDef="lang">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="tiny">Language</th>
                        <td mat-cell *matCellDef="let data" class="tiny" [matTooltip]="data.lang" [matTooltipShowDelay]="tooltipDelay">{{ data.lang }}</td>
                    </ng-container>

                    <!-- Senior center Column -->
                    <ng-container matColumnDef="program_name">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="large">Program(s)</th>
                        <td mat-cell *matCellDef="let data" [matTooltip]="data?.Programs?.name || noProgramFilterValue.name" [matTooltipShowDelay]="tooltipDelay" class="large">{{ data?.Programs?.name || noProgramFilterValue.name }}</td>
                    </ng-container>

                    <!-- Preferred channels Column -->
                    <ng-container matColumnDef="channels">
                        <th mat-header-cell *matHeaderCellDef class="large">Preferred channels</th>
                        <td mat-cell *matCellDef="let data" class="large">
                            <ng-container *ngIf="getUserChannels(data) as _channelValue">
                                <span [matTooltip]="_channelValue.join(', ')" [matTooltipShowDelay]="tooltipDelay">
                                    {{ _channelValue.join(', ') }}
                                </span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- Active Column -->
                    <ng-container matColumnDef="active">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="tiny">Active</th>
                        <td mat-cell *matCellDef="let data" class="tiny" [matTooltip]="data.active ? 'Yes' : 'No'" [matTooltipShowDelay]="tooltipDelay">{{ data.active ? 'Yes' : 'No' }}</td>
                    </ng-container>

                    <!-- Org. Client ID Column -->
                    <ng-container matColumnDef="org_client_id">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="medium">Org. Client ID</th>
                        <td mat-cell *matCellDef="let data" class="medium" [matTooltip]="data.org_client_id || ''" [matTooltipShowDelay]="tooltipDelay">
                                {{ data.org_client_id || '' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        class="row-hover" 
                        [class.disabled-row]="!row.active"
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                </table>
            </div>

            <!-- Row shown when there is no matching data. -->
            <div *ngIf="!noUsers && usersLength == 0" class="empty-message">
                <h6 style="text-align: center;">{{usersMessages.SEARCH_NO_RESULT_HEAD}}</h6>
                <div class="mat-subtitle-2 text-hint">{{usersMessages.SEARCH_NO_RESULT}}</div>
            </div>
        </span>

        <div *ngIf="!reqProgress && noUsers" class="emptyList" style="width: 400px !important; text-align: center;">
            <div class="mat-body-2 text-hint">{{getSelectorNote(initialNote)}}</div>
        </div>
        <mat-paginator
            #paginator
            [length]="usersLength"
            [pageIndex]="(usersList && usersList.page >= 1) ? (usersList.page - 1) : 0"
            [pageSize]="usersList?.limit || 20"
            [pageSizeOptions]="currentPaginateSizes"
            aria-label="paginate the survey list"
        ></mat-paginator>
    </mat-card>